// Imports for external libraries go here.
import { FC, useEffect, useState } from 'react';

import { LegalConsent, LegalConsentsProps, OnConsentChangeParams } from './LegalConsents.types';
import { getApplicableAndSortedConsents, getLegalConsents } from '../../utils/consents';
import { ConsentsList } from './ConsentsList';

// TODO: Allow LegalConsentsProps to recieve consentsState
// maitaining here might cause double rendering issue
// Eventhough it's bound by this component
export const LegalConsents: FC<LegalConsentsProps> = ({
  countryCode,
  isValidateErrors,
  local,
  option,
  consentsState, // ConsentsState is now passed through props
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [consentsReponse, setConsentsReponse] = useState([] as LegalConsent[]);
  const [localConsentsState, setLocalConsentsState] = useState(consentsState); // Local state for consents

  useEffect(() => {
    const fetchLegalConsents = async () => {
      const legalConsentsRep = await getLegalConsents({ local });

      const sortedConsentListData = getApplicableAndSortedConsents({
        allConsents: legalConsentsRep,
        countryCode,
        option,
      });

      setConsentsReponse(legalConsentsRep);
      setLocalConsentsState(sortedConsentListData);
      setIsLoading(false);
    };
    fetchLegalConsents();
  }, [local]);

  // If option changes then
  // We dont have to call the API again to to fetch the data
  // Pass the same response as previous and filter out applicable consent list with repect to new option value
  useEffect(() => {
    const sortedConsentListData = getApplicableAndSortedConsents({
      allConsents: consentsReponse,
      countryCode,
      option,
    });
    setLocalConsentsState(sortedConsentListData);
    setIsLoading(false);
  }, [option, countryCode]);

  const _onConsentChange = function ({ updatedConsentsList }: OnConsentChangeParams) {
    setLocalConsentsState(prev => ({ ...prev, list: updatedConsentsList }));
  };

  return (
    <>
      {isLoading && <div>Loading ...</div>}
      {!isLoading && (
        <ConsentsList
          consentState={localConsentsState}
          onConsentChange={_onConsentChange}
          validateErrors={isValidateErrors}
        />
      )}
    </>
  );
};
